import React, { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { UserContext } from '../../../App';
import { hanldeSignOut } from '../../Login/LoginMain/LoginManager';
import Pop from '../Pop/Pop';
import './Navbar.css';
import toast, { Toaster } from 'react-hot-toast';
import { useState } from 'react';
import { useEffect } from 'react';
import { AuthContext } from '../../Context/AuthContext';
import NavbarToggle from 'react-bootstrap/esm/NavbarToggle';
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';


const Navbar = () => {
    const { user, loading, error, dispatch } = useContext(AuthContext);
    const [isSticky, setSticky] = useState(false)

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 50) {
                setSticky(true)
            } else {
                setSticky(false)
            }
        })
    }, [])
    return (
        <nav className={`navbar navbar-expand-lg navbar-light ${isSticky ? "stickynav" : "normalnav"}`} expand="lg">
            <Toaster />
            <div className="container-fluid d-flex flex-column">
                <div className="mb-2 navbar-heading text-center">
                    <h3>
                        <Link className="navbar-h" to="/">Krishna Dental India</Link>
                    </h3>
                </div>
                {/* <NavbarToggle className="" type="button" aria-controls="navbarSupportedContent" >
                    <span className="navbar-toggler-icon"></span>
                </NavbarToggle> */}

                <div className="container" id="navbarSupportedContent">
                    <ul className="my-auto row list-unstyled text-center mb-2 mb-lg-0 ms-auto">
                        <li className="col nav-item">
                            <a className="nav-link active me-3 textDark" aria-current="page" href="/">HOME</a>
                        </li>
                        <li className="col nav-item active textDark">
                            <a className="nav-link me-3" href="#doctorContaints">ABOUT</a>
                        </li>

                        <li className="col nav-item textDark">
                            <a href='#ContactPage' className="nav-link me-3">CONTACT</a>
                            {/* <NavLink activeClassName="ContactPage" className="nav-link me-3" to="#ContactPage">CONTACT</NavLink> */}
                        </li>

                        <li className="col nav-item">
                            {/* <a className={`nav-link me-3 text-white ${isSticky ? "textDark" : "textWhite"}`} href="#BlogContaint">BLOG</a> */}
                            <a className="nav-link me-3 textDark" href="#BlogContaint">BLOG</a>
                        </li>

                        <li className="col nav-item">
                            <a className="nav-link me-3 textDark" href="#serviceContaint" >DENTAL SERVICE</a>
                        </li>

                        <li className="col nav-item">
                            <a className="nav-link me-3 textDark" href="#reviewsContaints">REVIEWS</a>
                        </li>

                        <div className=" col dropdown">

                            <li className="nav-item">
                                {user?.email ?
                                    <Pop />
                                    :
                                    <span>
                                        <button className="btn btn-primary"
                                            style={{
                                                backgroundImage: "linear-gradient(to right,#019CAD, #4880EC )",
                                                color: 'white'
                                            }}><Link className={`nav-link ${isSticky ? "textWhite" : "textWhite"}`} to="/login">LOG IN</Link></button>

                                    </span>
                                }
                            </li>

                        </div>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;